<template>
    <div class="mt-16">    
        <div class="flex flex-row justify-between gap-24">
            <h5>Restore Points</h5>
        </div>
    
        <sau-table 
            :data="restorePoints" 
            :collapse="true" 
            :config="tableConfig" 
            :loaded="!loading"
            class="mt-3"
            >
            <template #table-header>
                <tr>
                    <th>Time</th>
                    <th class="text-right">Actions</th>
                </tr>
            </template>
            <template v-slot="{ item }">
                <tr>
                    <td>{{ convertToLocalTime(item.created_date).format('LLLL') }}</td>
                    <td>
                        <button 
                            class="block ml-auto outline-none hover:text-red hover:underline"
                            @click.prevent="submit(item)"
                        >Restore</button>
                    </td>
                </tr>
            </template>
        </sau-table>
    </div>
</template>
<script>

import axios from 'axios';
import moment from 'moment';
import SauTable from "@js/components/utilities/SauTable";

export default {
    components: {
        SauTable
    },
    
    data () {
        return {
            loading: false,
            restorePoints: [],
            jobInfo: {},
            safeWord: 'RESTORE',
            tableConfig: {
                paginator: {
                    enabled: true,
                    itemsPerPage: 10,
                    page: 1,
                },
                search: {
                    enabled: false,
                }
            }
        };
    },

    created() {
        this.loading = true;
        this.getRestoreCapability().then(() => {
            this.loading = false;
        });
    },
    
    methods: {

        convertToLocalTime(dateTime) {
            return moment.utc(dateTime).local();
        },
        
        getRestoreCapability() {
            return axios.get(`/api/v2/services/${this.getServiceId()}/restore`)
                .then(( { data }) => {
                    this.restorePoints = data.data.restore_points;
                    this.jobInfo = data.data.job;
                    
                    const pollInterval = _.get(data, 'pollInterval', 0);
                    if(pollInterval > 0) {
                        setTimeout(() => {
                            this.getRestoreCapability();
                        }, pollInterval);
                    }
                }).catch(() => {
                    return;
                });
        },

        submit(restorePoint) {
            this.$swal({
                title: 'Confirm Restore',
                input: 'text',
                type: 'warning',
                width: '800px',
                html: `
                    <p>You are about to restore your server with the Restore Point <span class="sau-font-bold">${this.convertToLocalTime(restorePoint.created_date).format('LLLL')}</span>.</p>
                    <p>The restore process will take several minutes to complete. During this time your Cloud Server will be innaccessible, and any changes made after the restore point will be lost.</p>
                    <p>Once the restore has complete, your Cloud Server will be powered back on.</p>
                    <p class="mt-12">To confirm, please enter <strong class="sau-font-bold">${this.safeWord}</strong> into the text box below, and click 'Restore Server'</p>`,
                inputAttributes: {
                    autocapitalize: 'on'
                },
                showCancelButton: true,
                confirmButtonText: 'Restore Server',
                customContainerClass: 'default-style-swal',
                inputValidator: (value) => {
                    if(value != this.safeWord) {
                        return `Please type ${this.safeWord} into the text box above. This is case sensitive.`;
                    }
                },
                allowOutsideClick: false,
            }).then((result) => {
                if (result.value === this.safeWord) {
                    this.restore(restorePoint);
                }
            })
        },

        restore(restorePoint) {
            axios.post(`/api/v2/services/${this.getServiceId()}/restore`, {
                uid: restorePoint.uid
            
            }).then(() => {
                this.$swal({
                        type:'success',
                        title: 'Restore confirmed. Please allow a few minutes for the restore to complete.',
                        toast: true,
                        showConfirmButton: false,
                        timer: 3000
                    })
                    .then(() => {
                        window.location = `/service/vds/${this.getServiceId()}/summary`;
                    });
            }).catch(() => {
                this.$swal({
                        type: 'error',
                        title: 'Unable to restore your Cloud Server. Please contact support.',
                        toast: true,
                        showConfirmButton: false,
                        timer: 4000
                    });
            });
        },
    },
}
</script>
<style lang="scss" scoped>
    button.btn.btn-primary, button.btn.btn-secondary {
        color: #fff;
    }
</style>